<template  >
<v-layout column fill-height="">

    <not-toolbar-sub :not="not"/> 

     <!-- //access page -->
    <not-access-deny-page 
        v-if="!accessPage"
        :not="not"
        :notShow="true"/> 
    <!-- //page -->

    <v-layout column fill-height v-else>
        <not-page-spinner 
            :notShow="true" 
            :not="not"
            v-if="!page_show"/> 
        <div  v-else class="ma-10 ">
            <v-toolbar color="primary" dark="" tile=""  >
                <v-toolbar-title>
                    REPORTS / SMS
                </v-toolbar-title>
                <v-spacer></v-spacer> 
                
                <v-menu  bottom left 
                    v-model="menuSMS"
                    :close-on-content-click="false"
                    :nudge-width="250">
                    <template v-slot:activator="{ on }">
                    <v-btn
                        dark outlined="" rounded=""
                        icon
                        v-on="on" >
                        <v-icon>mdi-tune</v-icon>
                    </v-btn>
                    </template>

                    <v-card>
                        <v-card-title primary-title>
                            <v-layout >
                                CUSTOMIZE TABLE
                                <v-spacer></v-spacer>
                                <v-btn icon="" @click="menuSMS=false"><v-icon>close</v-icon></v-btn>
                            </v-layout>
                        </v-card-title>
                        <v-card-text>
                            <v-list subheader="" dense="">
                                <div v-for="(item, i) in xHeader_sms" :key="i">
                                    <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                    <v-list-item v-else  @click="not.TABLE_HEADER_SELECTOR(xHeader_sms,i)" >
                                        <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item> 
                                </div> 
                            </v-list> 
                            <v-layout >
                                <v-spacer></v-spacer>
                                <v-btn @click="menuSMS = false" color="primary">OK</v-btn>
                            </v-layout>
                        </v-card-text>
                        
                    </v-card> 
                </v-menu>
                <v-menu bottom left >
                    <template v-slot:activator="{ on }">
                    <v-btn 
                        dark
                        icon
                        v-on="on" >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>

                    <v-list> 
                        <v-list-item  @click="menuSMS=true" >
                            <v-list-item-title>Customize Table</v-list-item-title>
                        </v-list-item>  
                        <v-list-item  @click="deleteAllResponse()" >
                            <v-list-item-title>Delete ALL</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> 
            </v-toolbar>
            <v-tabs
                v-model="tab"
                background-color="primary"
                dark grow=""
                >
                <v-tab
                    v-for="(item, index) in items"
                    :key="item.tab"
                >
                    {{ item.tab }}
                    <v-chip v-if="index==0" small="" color="blue" class="ml-2">{{new_sms?new_sms.length:0}}</v-chip>
                    <v-chip v-if="index==1" small="" color="accent" class="ml-2">{{viewed_sms?viewed_sms.length:0}}</v-chip>
                    <v-chip v-if="index==2" small="" color="success" class="ml-2">{{submitted_sms?submitted_sms.length:0}}</v-chip> 
                </v-tab>
            </v-tabs>
            
            <div v-if="accessSMS('read')">
                <v-tabs-items v-model="tab">
                    <v-tab-item
                        v-for="item in items"
                        :key="item.tab"
                    > 
                        <v-card class="pa-2" tile="">
                            <!-- //Show  -->
                            <not-page-spinner 
                                :notShow="true" 
                                :not="not"
                                v-if="!page_show_response"/> 
                            <!-- // table -->
                            <div v-else-if="JOINED_SMS">
                                <v-card-title>
                                    {{not.TEXT_UP(item.tab)}}
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="headers('report')"
                                    :items="tab_reports"
                                    :search="search" >

                                    <template v-slot:top>
                                        
                                    </template> 
                                    <template v-slot:item.action="{ item }" > 
                                        <v-layout  wrap>
                                            <v-hover v-slot:default="{hover}" class="ma-1">
                                                <v-avatar tile color="blue" class="pa-1">
                                                    <v-icon size="18" dark @click="viewSMSInfo(item)" :class="hover?'white':''" :color="hover?'blue':'white'">mdi-information-outline</v-icon>
                                                </v-avatar>
                                            </v-hover> 
                                            <v-hover v-if="show_action_viewed" v-slot:default="{hover}" class="ma-1">
                                                <v-avatar tile color="accent" class="pa-1">
                                                    <v-icon size="30" dark @click="viewSMS(item)" :class="hover?'white':''" :color="hover?'accent':'white'">mdi-eye</v-icon>
                                                </v-avatar>
                                            </v-hover> 
                                            <v-hover v-if="show_action_submitted" v-slot:default="{hover}" class="ma-1">
                                                <v-avatar tile color="success" class="pa-1">
                                                    <v-icon size="30" dark @click="submitSMS(item)" :class="hover?'white':''" :color="hover?'success':'white'">done_all</v-icon>
                                                </v-avatar>
                                            </v-hover> 
                                            <v-hover v-slot:default="{hover}" class="ma-1">
                                                <v-avatar tile color="red" class="pa-1" >
                                                    <v-icon size="18" dark @click="deleteSMS(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-delete</v-icon>
                                                </v-avatar>
                                            </v-hover> 
                                            
                                        </v-layout>
                                        
                                    </template>
                                    <template v-slot:no-data>
                                        <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                            <v-icon>warning</v-icon>
                                            Empty
                                        </v-layout>
                                    </template>
                                </v-data-table>  
                            </div>
                        </v-card> 
                    </v-tab-item>
                </v-tabs-items> 
            </div>
            <div v-else>
                <v-layout  justify-center="" align-center="" class=" primary lighten-4 pa-9 ">
                    <v-icon size="50" color="primary">mdi-shield-account</v-icon>
                    <div>You do not have permission to read SMS.</div> 
                </v-layout> 
            </div>

        </div>

    </v-layout>

    <!-- edit -->
    <v-dialog v-model="dialog_view_response" persistent max-width="800px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">REPORT DETAILS</span>
                <v-spacer></v-spacer> 
                <v-btn @click="dialog_view_response = false" icon="" dark="" ><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text> 
                <v-layout row wrap class="pa-5">
                     
                    <v-flex xs12 md6 > 
                        OBSERVER NAME: {{input.observer?input.observer.first_name+" "+input.observer.last_name:"?:"}}
                    </v-flex> 
                    <v-flex xs12 md6  > 
                        OBSERVER PHONE: {{input.observer?input.observer.phone_number:"?:"}}
                    </v-flex> 
                    <v-flex xs12 md6  > 
                        QUESTION EMAIL: {{input.observer?input.observer.email:"?:"}}
                    </v-flex>  
                    <v-flex xs12 md6  > 
                        QUESTION GENDER: {{input.observer?input.observer.gender:"?:"}}
                    </v-flex> 
                    <v-flex xs12 class="py-2">
                        <v-divider></v-divider>  
                    </v-flex>
                    
                     
                    <v-flex xs12 md6 > 
                        MESSAGE: {{input.message}}
                    </v-flex>  
                    
                    <v-flex xs12 class="py-2">
                        <v-divider></v-divider>  
                    </v-flex>
                    <v-flex xs12 md4 > 
                        SUBMITTED DATE: {{input.created_at}}
                    </v-flex> 
                    <v-flex xs12 md4 > 
                        REGION: {{input.region_name}}
                    </v-flex>
                    <v-flex xs12 md4 > 
                        DISTRICT: {{input.district_name}}
                    </v-flex>  
                    <v-flex xs12 md4 > 
                        CONSTITUENCY: {{input.constituency_name}}
                    </v-flex>
                    <v-flex xs12 md4 > 
                        WARD: {{input.ward_name}}
                    </v-flex>  
                    <v-flex xs12 md4 > 
                        CENTRE: {{input.centre_name}}
                    </v-flex> 
                    
                </v-layout>
                <v-layout>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog_view_response = false" color="primary">OK</v-btn>
                </v-layout>
            </v-card-text> 
      </v-card>
    </v-dialog>

</v-layout>
</template>

<script> 
    
    let pageName = 'SMS'
    let ACTION_TIME = 100
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false, 
            page_show_response: false,

            menuSMS:false, 
            dialog_view_response:false,
             
            inputCode:null,
            input:{},
            search: '',
            xHeader_sms:[  
                {id:1,name:"Geneal",title:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"Time",show:true},
                {id:0,name:"From",show:true},

                {id:1,name:"location",title:true},
                {id:0,name:"Region Name",show:false}, 
                {id:0,name:"Region Code",show:false}, 
                {id:0,name:"District Name",show:true}, 
                {id:0,name:"District Code",show:false}, 
                // {id:0,name:"Constituency Name",show:true}, 
                // {id:0,name:"Constituency Code",show:false}, 
                // {id:0,name:"Ward Name",show:true}, 
                // {id:0,name:"Ward Code",show:false}, 
                // {id:0,name:"Centre Name",show:true}, 
                // {id:0,name:"Centre Code",show:false}, 

                {id:1,name:"Action",title:true},
                {id:0,name:"Question Number",show:true},
                {id:0,name:"Message",show:true},
                {id:0,name:"Device",show:false}, 
                {id:26,name:"ACTION",show:true},  
            ],
            xHeader_sms2:[ 
                {id:1,name:"Geneal",title:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"time",show:true},
                {id:0,name:"from",show:true},
                {id:0,name:"message",show:true},
                {id:0,name:"device",show:true}, 
            ],

            tab: null,
        items: [  
          { tab: 'NEW SMS', content: 'Tab 2 Content' }, 
          { tab: 'Viewed SMS', content: 'Tab 2 Content' }, 
          { tab: 'Submitted', content: 'Tab 2 Content' },  
        ],
             
        }),  
        created(){
             this.EventBus.$on('notYesDialog', this.notYesDialog); 
        },
        mounted() {   
            this.pageLoad(1000)  
        },
        computed:{ 
            accessSMS(){
                return permission=>{
                    if (permission === "read") {
                        return this.not.ACCESS_READ("responses") 
                    }else if (permission === "write") {
                        return this.not.ACCESS_WRITE("responses") 
                    }else if (permission === "edit") {
                        return this.not.ACCESS_EDIT("responses") 
                    }else if (permission === "delete") {
                        return this.not.ACCESS_DELETE("responses") 
                    }else{
                        return false
                    }
                }
            },
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            us(){
                return this.not.us
            },
            ud(){
                return this.not.ud
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },

            sms(){  
                let sms = this.$store.getters.getSMS
                if(!sms){return null}
                // return sms.filter(sm=>{
                //     return sm.user_key == this.ud.uid
                // })
                
                return sms 
            },
            JOINED_SMS(){
                let sms = this.sms  
                if(!sms){return null}
                let joinedquestionSMS = this.not.JOIN_SMS(sms)
                return joinedquestionSMS
            },

            tab_reports(){
                let tab = this.tab
                let data = null
                if (tab===0) {
                    data = this.new_sms
                }else if (tab===1) {
                    data = this.viewed_sms
                }else if (tab===2) {
                    data = this.submitted_sms
                } 
                return data
            },
 
            all_sms(){
                let sms = this.JOINED_SMS  
                return sms
            }, 
            new_sms(){
                let all_sms = this.all_sms
                if(!all_sms){return null}
                let viewed_sms = all_sms.filter(sm=>{   
                    if (sm.submitted===true) {return false}
                    if (sm.viewed===true) {return false}
                    return true
                })
                return viewed_sms
            }, 
            viewed_sms(){
                let all_sms = this.all_sms
                if(!all_sms){return null}
                let viewed_sms = all_sms.filter(sm=>{   
                    if (sm.submitted===true) {return false}
                    if (!this.us) {return false}
                    return sm.viewed_uid == this.us.uid
                })
                return viewed_sms
            }, 
            submitted_sms(){
                let all_sms = this.all_sms
                if(!all_sms){return null}
                let submitted_sms = all_sms.filter(sm=>{   
                    if (!this.us) {return false}
                    return sm.submitted_uid == this.us.uid
                })
                return submitted_sms
            },  

            show_action_viewed(){
                let show = true
                let tab = this.tab 
                if (tab===1) {
                    show = false
                } 
                if (tab===2) {
                    show = false
                } 
                return show
            }, 
            show_action_submitted(){
                let show = true
                let tab = this.tab 
                if (tab===0) {
                    show = false
                } 
                if (tab===2) {
                    show = false
                } 
                return show
            }, 
            
        },
        //------------methods---------------
        methods: { 
            clicked(){ 
            },
            notYesDialog(action){
                if (action) {  
                    if (action.code ===pageName+'=FLAG-SMS') { 
                        if (this.input.check) {  
                            this.input.check = false 
                            this.not.notDialogP(true,false,'Saving...')
                            setTimeout(() => { 
                                this.input.loading = true  
                                this.$store.dispatch("fi_update",{
                                    action:"SMS",
                                    path:"SMS/MS2021/"+action.details.key+"/",
                                    data:action.details,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);   
                        } 
                    } 
                    if (action.code ===pageName+'=ADD-SMS-SUCCESS') {
                        this.dialog_add_report = false
                    }
                    if (action.code ===pageName+'=EDIT-SMS-SUCCESS') {
                        this.dialog_view_response = false
                    }


                    if (action.code ===pageName+'=CONFIRM-DELETE-SMS') {
                        if (this.input.check) {  
                            setTimeout(() => { 
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting this SMS.","CANCEL","CONFIRM",{
                                    ...action,
                                    code:pageName+"=DELETE-SMS",
                                }) 
                            }, ACTION_TIME);
                        }  
                    } 
                    if (action.code ===pageName+"=CONFIRM-DELETE-ALL-SMSES") {
                        if (this.input.check) {  
                            setTimeout(() => {
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting ALL SMSes. This action can not be reversed.","CANCEL","CONFIRM",{
                                    ...action,
                                    code:pageName+"=DELETE-ALL-SMSES",
                                })  
                            }, ACTION_TIME);
                        }   
                    } 
                    
                    if (action.code ===pageName+'=DELETE-SMS') {
                        if (this.input.check) {  
                            this.input.check = false  
                            setTimeout(() => { 
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered.","OK")
                                } else {
                                    this.$store.dispatch("fi_delete",{
                                        action:"SMS",
                                        path:"SMS/MS2021/"+action.sms.key+"/"
                                    }) 
                                }
                            }, ACTION_TIME);   
                        }  
                    } 
                    if (action.code ===pageName+'=DELETE-ALL-SMSES') {
                        if (this.input.check) {  
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered.","OK")
                                } else {
                                    this.$store.dispatch("fi_delete",{
                                        action:"SMS",
                                        path:"SMS/MS2021/" 
                                    }) 
                                }
                            }, ACTION_TIME);   
                        }     
                    }     
                } 
            }, 
            viewSMSInfo(response){
                this.inputCode = null
                this.input = {
                    ...response
                } 
                this.dialog_view_response = true
            },
            viewSMS(sms){ 
                this.input={}
                this.input.check = true 
                let key = sms.key
                let oldSMS = this.$store.getters.getSMSByKey(key)
                 
                
                if (oldSMS) {
                    this.not.notDialog(true,true,"FLAG VIEWED SMS",'Are you sure you want to flag this SMS as viewed SMS?','CANCEL',"FLAG",{
                        code:pageName+"=FLAG-SMS",
                        details:{
                            ...this.input,
                            ...oldSMS,
                            viewed:true,
                            viewed_uid:this.us?this.us.uid:null
                        }
                    }) 
                    
                } else {
                    this.not.notDialog(true,true,null,'ERROR','OK') 
                }
            }, 
            submitSMS(sms){ 
                this.input={}
                this.input.check = true 
                let key = sms.key
                let oldSMS = this.$store.getters.getSMSByKey(key)
                if (oldSMS) {
                    this.not.notDialog(true,true,"FLAG SUBMITTED SMS",'Are you sure you want to flag this SMS as submitted SMS?','CANCEL',"FLAG",{
                        code:pageName+"=FLAG-SMS",
                        details:{
                            ...this.input,
                            ...oldSMS,
                            submitted:true,
                            submitted_uid:this.us?this.us.uid:null
                        }
                    })  
                } else {
                    this.not.notDialog(true,true,null,'ERROR','OK') 
                }
            }, 
            deleteSMS(sms){
                let ud = this.ud
                let permission = true
                if (permission) { 
                    this.input.check = true 
                    this.not.notDialog(true,true,"DELETE SMS",'Are you sure you want to delete this SMS?','CANCEL',"SMS",{
                        code:pageName+"=CONFIRM-DELETE-SMS",
                        sms:sms
                    })  
                    
                } 
            }, 
            deleteAllResponse(){
                let ud = this.ud
                let permission = true
                if (permission) { 
                    this.input.check = true
                    this.not.notDialog(true,true,"DELETE ALL SMSES",'Are you sure you want to delete ALL uploaded SMSes?','CANCEL',"DELETE",{
                        code:pageName+"=CONFIRM-DELETE-ALL-SMSES",
                    })   
                } 
            },

            //Heades
            headers(type){
                let hds = null
                if (type === 'report') {
                    hds = this.xHeader_sms
                }else if (type === 'excel'){
                    hds = this.xHeader_sms2
                } 
                let headers = this.not.TABLE_HEADERS(hds) 
                return headers
            },  
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                   //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/sms'
                        }) 
                        let updating = ps.find(process=>{
                            return process.name == "updating/sms" 
                        })  
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/sms'
                        })  

                        if (logging) {
                            this.page_show =false
                            this.not.notDialogP(true,true,'Logging...')
                        }else{ 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        if (getting) {
                            this.page_show_response =false
                            this.not.notDialogP(true,false,'Loading...')
                        }else{ 
                            this.page_show_response =true
                        }

                        
                         
                        if (updating) { 
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }   
                        if (deleting) {
                            this.not.notDialogP(true,false,'Deleting...') 
                        }else{ 
                        }  

                        

                        //IF ALL DONE
                        if (ps.length===0) { 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                            this.not.notDialogP(false)
                        }
                    }else{
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        this.not.notDialogP(false)
                    }

                     


                     if (res.res==='updating/SMS/successful') { 
                        this.not.notDialog(true,true,'Successful','SMS successfully edited.','','OK',{code:pageName+'=FLAG-SMS-SUCCESS'})
                        this.input.loading = false
                        this.dialog_view_response = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='updating/SMS/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while editing the SMS. Make sure your password is correct or contact admin.','','OK',{code:pageName+'=FLAG-SMS-ERROR'})
                        this.input.loading = false
                        this.dialog_view_response = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                     
                    if (res.res==='deleting/SMS/successful') { 
                        this.not.notDialog(true,true,'Successful','SMS successfully deleted.','','OK',{code:pageName+'=DELETE-SMS-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='deleting/SMS/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting the SMS. Make sure your password is correct or contact admin.','','OK',{code:pageName+'=DELETE-SMS-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                    
 
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
 
